import { IngredientType } from './pricing.model';

export interface TransferRequestType {
  name: string;
  id: string;
  store_id: string;
  from_store_id: string;
  transfer_type: string;
  request_index?: any;
  status: ENUM_TRANSFER_STATUS;
  created_at: string;
  updated_at: string;
  code: number;
  items: TransferRequestItemType[];
}

export interface TransferRequestItemType {
  id: string;
  ingredient_id: string;
  ingredient_name: string;
  store_transfer_request_id: string;
  quantity: number;
  quantity_received?: any;
  ingredient: IngredientType;
  quantity_sent?: any;
  completed: boolean;
  batches: any[];
  created_at: string;
  updated_at: string;
}

export enum ENUM_TRANSFER_STATUS {
  ALL = 'ALL',
  RECEIVED = 'RECEIVED',
  REQUESTED = 'REQUESTED',
  SENT = 'SENT',
  REJECTED = 'REJECTED'
}
